import { StatisticalAnalysisGroupingResponseField } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-grouping/statistical-analysis-grouping.dto'
import { GridItemData } from 'vue-grid-layout'

export interface StatisticalAnalysisViewDetailTableGroupingGridItem extends StatisticalAnalysisGroupingResponseField, GridItemData {
}
export interface StatisticalAnalysisViewDetailTableGroupingState {
    loading: boolean
    externalLoading: boolean
    fields: StatisticalAnalysisGroupingResponseField[]
    fieldsSelected: StatisticalAnalysisViewDetailTableGroupingGridItem[]
    temporalFields: StatisticalAnalysisGroupingResponseField[]
    temporalSelected: StatisticalAnalysisViewDetailTableGroupingGridItem[]
}
export const initialStatisticalAnalysisViewDetailTableGroupingState =
    (): StatisticalAnalysisViewDetailTableGroupingState => ({
        loading: false,
        externalLoading: false,
        fields: [],
        fieldsSelected: [],
        temporalFields: [],
        temporalSelected: []
    })
